var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('locum-booking-confirmed'),_c('locum-upcoming-bookings'),_c('locum-past-bookings'),_c('locum-increase-availability-ad')],1)}
var staticRenderFns = []

export { render, staticRenderFns }